import EventEditTagGroup from '@/screens/EventEditTagGroup';

export default function PrivateEventCreateSportRoute() {
  return <EventEditTagGroup />;
}
